import { Tile } from 'ia-react-core';
import styled from 'styled-components';
import { ReactComponent as DocumentsIcon } from '../../../../assets/documents.svg';

export const StyledTile = styled(Tile)`
  text-align: center;
  padding-bottom: 20px;
`;

export const StyledDocumentsIcon = styled(DocumentsIcon)`
  width: 60px;
  margin-top: 10px;
  margin-bottom: 20px;
`;
